import React from "react"
import { Query } from "@apollo/client/react/components"
import AnnouncementContainer, {
  ANNOUNCEMENT_COUNT,
} from "./AnnouncementContainer"
import WrapWithFetch from "../WrapWithFetch"
import LoadingPlaceholder from "./LoadingPlaceholder"
import ErrorLoading from "./ErrorLoading"
import { getAnnouncementQuery } from "../../queries/announcement"
import { withAuthProvider } from "../../../lib/auth"
import { useMembershipJourney } from "../../../hooks/useMembershipJourney"
import { getAnnouncementGroup } from "../../utils"

export const AnnouncementWrapper = ({
  data,
  loading,
  error,
  refetch,
  card,
  collapsed,
  isFetching,
  reload,
}) => {
  if (loading || isFetching) {
    return <LoadingPlaceholder card={card} />
  }
  if (error) return <ErrorLoading {...{ refetch, reload, collapsed }} />

  const { announcements } = data
  return <AnnouncementContainer {...{ announcements, collapsed, card }} />
}

export const AnnouncementFetch = ({
  isFetching,
  reload,
  collapsed,
  card,
  authReady,
  me,
}) => {
  const { person, loading: personLoading } = useMembershipJourney()
  const routingMe = person || me

  if (collapsed) return null
  if (!authReady || personLoading) return <LoadingPlaceholder card={card} />

  const variables = {
    group: getAnnouncementGroup(routingMe),
    section: routingMe.section?.name || me.section?.name,
    limit: ANNOUNCEMENT_COUNT,
  }

  return (
    <Query query={getAnnouncementQuery} variables={variables}>
      {props =>
        AnnouncementWrapper({ ...props, card, collapsed, isFetching, reload })
      }
    </Query>
  )
}

export const Announcements = WrapWithFetch(AnnouncementFetch)

export default withAuthProvider(Announcements)
